import { Injectable } from '@angular/core';

import { mergeMap } from 'rxjs';

import { CamBaseService, GraphEndpoint, HandleComplexRequest } from '@camelot/server';

import {
  UserCalendarSubscription,
  UserCalendarSubscriptionCreationPayload,
  UserCalendarSubscriptionModifierPayload,
  userCalendarSubscriptionProps,
} from './dto/user-calendar-subscription';
import { CREATE_USER_CALENDAR_SUBSCRIPTION, UPDATE_USER_CALENDAR_SUBSCRIPTION } from './mutations';
import { GET_USER_CALENDAR_SUBSCRIPTION_BY_USER } from './queries';

const graphEndpoint: GraphEndpoint = {
  clientName: 'planningService',
  endpoint: 'planning',
};

@Injectable({
  providedIn: 'root',
})
export class CamUserCalendarSubscriptionService extends CamBaseService {
  public userCalendarSubscription = new HandleComplexRequest<UserCalendarSubscription>();

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: graphEndpoint });
  }

  public fetchUserCalendarSubscriptionForUser$(userId: string) {
    return this.userCalendarSubscription.fetch(
      userId,
      this._graphService.fetchQuery<UserCalendarSubscription>(
        GET_USER_CALENDAR_SUBSCRIPTION_BY_USER(
          userId,
          `
              ${userCalendarSubscriptionProps.get('id')}
              ${userCalendarSubscriptionProps.get('userId')}
              ${userCalendarSubscriptionProps.get('isSync')}
              ${userCalendarSubscriptionProps.get('userEmail')}
              `
        ),
        'userCalendarSubscription',
        graphEndpoint.clientName
      )
    );
  }

  public createUserCalendarSubscription$(payload: UserCalendarSubscriptionCreationPayload) {
    return this._graphService
      .mutateBuilder<UserCalendarSubscription>(CREATE_USER_CALENDAR_SUBSCRIPTION(payload), graphEndpoint.clientName, [
        'userCalendarSubscription',
      ])
      .pipe(mergeMap(() => this.fetchUserCalendarSubscriptionForUser$(payload.userId)));
  }
  public updateUserCalendarSubscription$(payload: Partial<UserCalendarSubscriptionModifierPayload>, userId: string) {
    return this._graphService
      .mutateBuilder<UserCalendarSubscription>(UPDATE_USER_CALENDAR_SUBSCRIPTION(payload), graphEndpoint.clientName, [
        'userCalendarSubscription',
      ])
      .pipe(mergeMap(() => this.fetchUserCalendarSubscriptionForUser$(userId)));
  }
}
